// Maps each workflow step id to its run decoration: the execution indices where it ran (occurrences, for the scrubber and
// the "N of X" iteration tag), whether any of those occurrences is where a failure originated, and the status the tree row
// shows for it. Ancestors of a failed step are recorded as failed too, so only origin failures get the error outline — see
// buildWorkflowRunFailureOrigins. A step that failed on any occurrence reads as failed; otherwise its last occurrence wins.
const buildWorkflowRunStepStatusByStepId = ({ rows, failureOriginIndexes } = {}) => {
  if (!Array.isArray(rows)) {
    return {};
  }

  const origins = new Set(Array.isArray(failureOriginIndexes) ? failureOriginIndexes : []);
  const map = {};

  rows.forEach((row) => {
    const stepId = row?.stepId;

    if (!stepId) {
      return;
    }

    if (!map[stepId]) {
      map[stepId] = { occurrences: [], hasFailureOrigin: false, statusVariant: 'neutral', statusLabel: 'Unknown' };
    }

    map[stepId].occurrences.push(row.index);

    if (origins.has(row.index)) {
      map[stepId].hasFailureOrigin = true;
    }

    if (map[stepId].statusVariant !== 'failure') {
      map[stepId].statusVariant = row.statusVariant || 'neutral';
      map[stepId].statusLabel = row.statusLabel || 'Unknown';
    }
  });

  return map;
};

export default buildWorkflowRunStepStatusByStepId;
